import Container from "@mui/material/Container";
import React from "react";
import Sella from "./Sella.png";
import { Box, Button, Grid, Link } from "@mui/material";
import goal from "./goal.png";
import "../cssPages/Check.css";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const UserModified = styled(Box)({
  fontFamily: "Montserrat, sans-serif",
  fontSize: "22px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  textAlign: "center",
  color: "#1b1b1b",
});

const CheckImg = styled(Grid)({
  marginTop: "100px",
});

const FeedbackMessage = styled(Grid)({
  fontFamily: "Lato",
  fontSize: "18px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.44",
  letterSpacing: "0.13px",
  textAlign: "center",
  color: "#4d606f",
});

const CloseButton = styled(Button)({
  width: "300px",
  borderRadius: "0px",
  height: "50px",
  boxShadow: "none",
  textTransform: "none",
  fontFamily: "Montserrat, sans-serif",
  fontSize: "12px",
  fontWeight: "600",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#339aef",
  "&:hover": {
    backgroundColor: "#339aef",
  },
  "&:active": {
    backgroundColor: "#339aef",
  },
  "&:focus": {
    backgroundColor: "#339aef",
  },
});

const ButtonBox = styled(Box)({
  textAlign: "center",
  marginTop: "70px",
});

const ContactLink = styled(Link)({
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.54",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#00cb4d",
});

const HelperText = styled(Box)({
  marginTop: "168px",
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.54",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#919191",
});

const SimpleBox = styled(Box)({
  textAlign: "center",
});

const Informativa = styled(Box)({
  marginBottom: "36px",
  opacity: "0.5",
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#333",
});

function UserNameModified() {
  let navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const close = () => {
    navigate("/");
  }
  return (
    <Container maxWidth="xl">
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <img class="logo" src={Sella}></img>
        </Grid>
      </Grid>

      <CheckImg container>
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={4}>
          <center>
            <img class="check2" src={goal}></img>
          </center>
        </Grid>
        <Grid item xs={0} sm={0} md={4}></Grid>
      </CheckImg>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <UserModified>Username aggiornato</UserModified>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div class="Line-8"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <FeedbackMessage>
            Il tuo username è stato correttamente modificato.
          </FeedbackMessage>
        </Grid>
      </Grid>

      <Grid container spacing={4}>
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={4}>
          <ButtonBox>
            <CloseButton
              fullWidth
              onClick={close}
            >
              CHIUDI
            </CloseButton>
          </ButtonBox>
        </Grid>
        <Grid item xs={0} sm={0} md={4}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <HelperText>
            Vuoi maggiori informazioni o hai bisogno di assistenza?
          </HelperText>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SimpleBox>
            <ContactLink href="/banca-on-line/contatti-e-assistenza">contatta il servizio clienti</ContactLink>
          </SimpleBox>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div class="Line-8"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Informativa>
            © 1996-2018 - Banca Sella S.p.A. - PI 02224410023 - Privacy
          </Informativa>
        </Grid>
      </Grid>
    </Container>
  );
}

export default UserNameModified;